import { render } from "./OrdersSideBar.vue?vue&type=template&id=2c3d33bb&scoped=true"
import script from "./OrdersSideBar.vue?vue&type=script&lang=js"
export * from "./OrdersSideBar.vue?vue&type=script&lang=js"

import "./OrdersSideBar.vue?vue&type=style&index=0&id=2c3d33bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3d33bb"]])

export default __exports__